import { createSlice } from "@reduxjs/toolkit";
import {
  AddMaintenanceAction,
  DeleteMaintenanceAction,
  GetAllMaintenanceAction,
  GetAllSettingsAction,
  GetDefaultPreferencesAction,
  UpdateDefaultPreferencesAction,
  UpdateMaintenanceAction,
  UpdateSettingsAction,
} from "store/middlewares/settings/settings";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    settingsLoading: false,
    settings: null,
    maintenanceLoading: false,
    maintenance: null,
  },
  extraReducers(builder) {
    builder
      // Get All Settings
      .addCase(GetAllSettingsAction.pending, (state) => {
        state.settingsLoading = true;
        state.settings = null;
      })
      .addCase(GetAllSettingsAction.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = action.payload.response;
      })
      .addCase(GetAllSettingsAction.rejected, (state) => {
        state.settingsLoading = false;
        state.settings = null;
      })
      // Update Settings
      .addCase(UpdateSettingsAction.fulfilled, (state, action) => {
        state.settingsLoading = false;
        state.settings = { ...state.settings, ...action.payload.response };
      })

      // Get Default Preferences
      .addCase(GetDefaultPreferencesAction.pending, (state) => {
        state.preferencesLoading = true;
        state.preferences = null;
      })
      .addCase(GetDefaultPreferencesAction.fulfilled, (state, action) => {
        state.preferencesLoading = false;
        state.preferences = action.payload.response;
      })
      .addCase(GetDefaultPreferencesAction.rejected, (state) => {
        state.preferencesLoading = false;
        state.preferences = null;
      })
      // Update preferenes
      .addCase(UpdateDefaultPreferencesAction.fulfilled, (state, action) => {
        state.preferencesLoading = false;
        state.preferences = {
          ...state.preferences,
          ...action.payload.response,
        };
      })
      // Get All Maintenance
      .addCase(GetAllMaintenanceAction.pending, (state) => {
        state.maintenanceLoading = state?.maintenance?.data?.length > 0 ? false : true;
        state.maintenance = state?.maintenance || null;
      })
      .addCase(GetAllMaintenanceAction.fulfilled, (state, action) => {
        state.maintenanceLoading = false;
        state.maintenance = action.payload.response;
      })
      .addCase(GetAllMaintenanceAction.rejected, (state) => {
        state.maintenanceLoading = false;
        state.maintenance = null;
      })

      // Update Maintenance
      .addCase(UpdateMaintenanceAction.fulfilled, (state, action) => {
        state.maintenanceLoading = false;
        state.maintenance = {
          ...state.maintenance,
          data: (state.maintenance?.data || []).map((item) =>
            item.id === action.payload.response.id ? action.payload.response : item)
        };
      })
      // Add Maintenance
      .addCase(AddMaintenanceAction.fulfilled, (state, action) => {
        state.maintenanceLoading = false;
        state.maintenance = { ...state.maintenance, data: [...(state.maintenance?.data || []), action.payload.response] };
      })
      // Delete Maintenance
      .addCase(DeleteMaintenanceAction.fulfilled, (state, action) => {
        state.maintenanceLoading = false;
        state.maintenance = { ...state.maintenance, data: (state.maintenance?.data || []).filter((item) => item.id !== action.payload.response.id) };
      });
  },
});

export default settingsSlice.reducer;
